<template>
<div style="margin:5px;">
      <br>
          <Row><Col span="12" offset="10"><div class="myTitle" >巡查统计</div></Col></Row>
        <br>
        <Row>
                <div class="queryForm">
                    <Form ref="queryFormRef" :model="queryForm" :label-width="110" inline>
                         <FormItem label="统计名称" prop="name" >
                            <Input v-model="queryForm.name" placeholder="请输入统计名称" style="width:250px"></Input>
                        </FormItem>
                        <FormItem label="创建时间：" >
                          <DatePicker type="date" placeholder="开始时间" format="yyyy-MM-dd"
                            v-model="queryForm.startDate" @on-change="queryForm.startDate=$event" ></DatePicker>
                          ——
                          <DatePicker type="date" placeholder="结束时间"
                              v-model="queryForm.endDate" format="yyyy-MM-dd"  @on-change="queryForm.endDate=$event" ></DatePicker>
                       </FormItem>
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                    <Button type="success"  @click="resetQueryForm">重置</Button>
                    </form>
                </div>
            </Row>
            
        
             <br>
      <Row >
          <Col span="10" offset="1">
            <div>
              <Button type="info"  @click="openAddForm" >生成统计</Button>
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row }" slot="action">
               
                    <Button type="info" size="small" @click="openUpdateForm(row)">查看</Button>
                    <Button v-if="row.downloadUrl!=''&&row.downloadUrl!='error'" type="success" size="small" @click="exportRows(row)">导出</Button>
                    <Button v-if="row.downloadUrl==''" type="warning" size="small" >生成中</Button>
                     <Button v-if="row.downloadUrl=='error'" type="warning" size="small" >生成失败</Button>
                   <Button type="error" size="small" @click="deleteRows(row)">删除</Button>
                </template>
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <ReportEdit ref="reportEdit"></ReportEdit>
 
</div>
</template>

<script>

  import ReportEdit from '@/pages/platform/report/ReportEdit';
  import moment from 'moment'

  export default {
    components: {
        ReportEdit
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
      //打开新增对话框
      openAddForm() {
        this.$refs.reportEdit.openModal('生成统计',null);
      },
      //查看
      openUpdateForm(row) {
           this.$router.push({ path: '/home/main/report/ReportDetailed',
                               query: {reportName: row.reportName,_id: row._id,createTime:row.createTime}})       
      },
 
     //执行删除操作
            deleteRows(row) {               
                this.$Modal.confirm({
                    title: '删除',
                      content: `确认要删除\"${row.reportName}\"吗?`,
                    onOk: () => {
                         this.loading = true
                         let url = `/api/report/del_report_data`
                            this.req({
                                url: url,
                                method: 'post',
                                data: {
                                    _id: row._id
                                }
                            }).then(response => {
                                this.$Message.success(
                                {
                                    content:response.data.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
                        }).catch(error => {
                                this.$Message.error('服务器错误:' + error)
                        })
                    },
                    onCancel: () => {
                       // this.loading = false
                    }
                });

            },
            //导出
            exportRows(row) {
                let a = document.createElement('a')
                 a.target = "_blank";
                let event = new MouseEvent('click')
                // 自定义下载后的名称
                a.download = row.reportName
                a.href = row.downloadUrl
                a.dispatchEvent(event)

            },
      
      loadPage() {
         this.loading = false
        let url   = `api/report/get_report_list`
        let  _startDate= this.queryForm.startDate
        if(this.queryForm.startDate!=''){
              _startDate=  moment(this.queryForm.startDate).format('YYYY-MM-DD')
        }
         let  _endDate= this.queryForm.endDate
        if(this.queryForm.endDate!=''){
              _endDate=  moment(this.queryForm.endDate).format('YYYY-MM-DD')
        }
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            reportName:this.queryForm.name,
            startTime:_startDate,
				  	endTime:_endDate
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
      queryBtn(){
                this.current = 1
                this.loadPage()
      },
   
     
     
    },
    mounted: function () {
      this.loadPage();
       this.loading = false
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        columns4: [{
            type: 'index',
            title:'序号',
            width: 80,
            align: 'center',
          },
          {
            title: '统计名称',
            align: 'center',
            key: 'reportName',
          },
          {
            title: '统计时间段',
            align: 'center',
            key: 'category',
             render: (h,params)=>{
                         let text=params.row.startTime +" ~ "+params.row.endTime
                          return h('div', text)
                        }
          },  
           {
            title: '创建时间',
            align: 'center',
            key: 'createTime'
          },        
          {
            title: '操作',
            slot: 'action',
            width: 230,
            align: 'center'
          }
        ],
       //查询表单的初始值
          queryForm: {
              name: '',
              startDate:'',
              endDate:'',
          }
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/report/ReportList.vue